export class UpdateRoleResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "role",
            "baseName": "role",
            "type": "Role",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRoleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
